// Opus packet arithmetic: how many 48 kHz samples a packet carries, decoded from
// its TOC byte (RFC 6716 §3.1). Needed for Ogg granule positions — the remux
// never decodes audio, only counts it.

/** Samples per frame at 48 kHz for each TOC config (0–31). */
function frameSamples(configuration: number): number {
  if (configuration < 12) {
    // SILK NB/MB/WB: 10, 20, 40, 60 ms in groups of four.
    return [480, 960, 1920, 2880][configuration % 4]!;
  }
  if (configuration < 16) {
    // Hybrid SWB/FB: 10, 20 ms in groups of two.
    return [480, 960][configuration % 2]!;
  }
  // CELT NB/WB/SWB/FB: 2.5, 5, 10, 20 ms in groups of four.
  return [120, 240, 480, 960][configuration % 4]!;
}

/** Total 48 kHz samples in one Opus packet. */
export function packetSamples(packet: Uint8Array): number {
  if (packet.length === 0) {
    return 0;
  }
  const toc = packet[0]!;
  const perFrame = frameSamples(toc >> 3);
  const code = toc & 0x03;
  let frames: number;
  if (code === 0) {
    frames = 1;
  } else if (code === 3) {
    frames = packet.length > 1 ? packet[1]! & 0x3f : 0;
  } else {
    frames = 2;
  }
  return frames * perFrame;
}
